export default __webpack_public_path__ + "static/media/cow-painting.802c3805.png";